"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPoliceBadge = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M13.1 21.68s-.513.32-1.1.32c-.587 0-1.082-.314-1.082-.314-1.575-1.038-2.77-2.215-3.586-3.018L7 18.343C5.502 16.889 4 14.253 4 12V7.006s0-.541.323-1.033c.196-.31.464-.57.781-.755l6-3.008c.298-.14.597-.21.896-.21.31.003.617.075.896.211l6 3.007c.34.166.624.429.817.755.313.511.287 1.035.287 1.035V12c0 2.229-1.533 4.893-3.003 6.343l-.283.28c-.814.813-2.018 2.012-3.614 3.057zm-.343-14.193C12.637 7.162 12.385 7 12 7s-.645.161-.781.483l-.559 1.79H8.71c-.386.027-.616.203-.69.527-.073.325.048.626.363.904l1.443 1.108-.62 2.173c-.092.335-.011.614.242.835.252.22.582.238.989.053L12 13.784l1.523 1.066c.353.207.677.197.972-.03.295-.227.38-.514.258-.862l-.624-2.146 1.49-1.108c.319-.28.437-.581.354-.904-.082-.323-.318-.499-.706-.527h-1.965l-.546-1.786z' }))); };
exports.default = SvgPoliceBadge;
//# sourceMappingURL=PoliceBadge.js.map